import { Button } from '@/components/ui/button';

interface NotFoundPageProps {
  onBack: () => void;
}

export function NotFoundPage({ onBack }: NotFoundPageProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground px-4">
      <div className="text-9xl font-bold text-[rgba(83,58,253,0.12)] mb-4">404</div>
      <h1 className="text-2xl font-semibold mb-2">页面未找到</h1>
      <p className="text-muted-foreground mb-8">Page not found</p>
      <Button className="bg-[#533afd] hover:bg-[#412fd9]" onClick={onBack}>
        返回首页 / Back to home
      </Button>
    </div>
  );
}
